export default {"src":"/_next/static/media/icon-line-solid.742aae0e.svg","height":3,"width":25,"blurWidth":0,"blurHeight":0};